import * as h2Api from '../h2Api'

export const REPORT_DATA_LOAD = 'PORTFOLIO_SUMMARY_REPORT_REPORT_DATA_LOAD'

export const TOGGLE_FILTER = 'PORTFOLIO_SUMMARY_REPORT_TOGGLE_FILTER'

export const FILTER_NUM_TO_DISPLAY = 'FILTER_NUM_TO_DISPLAY'

export const REPORT_DATA_SAVE_PORTFOLIO = 'REPORT_DATA_SAVE_PORTFOLIO'

export const REPORT_DATA_SAVE_PORTFOLIO_COMPLETE = 'REPORT_DATA_SAVE_PORTFOLIO_COMPLETE'

export const REPORT_DATA_SAVE_PORTFOLIO_DISMISS = 'REPORT_DATA_SAVE_PORTFOLIO_DISMISS'

export const TOGGLE_FILTER_TO = 'PORTFOLIO_REPORT_TOGGLE_FILTER_TO'

export const REPORT_DATA_SAVE_PORTFOLIO_ERROR = 'REPORT_DATA_SAVE_PORTFOLIO_ERROR'

export const defaultPortfolioSummaryFilters = {
  showIP: true,
  showWIP: true,
  showSP: true,
  showClusters: true,
  showOccupations: true,
  showFlaggedItems: true,
  showPlans: true,
  showJournals: true,
  showResumes: true,
  showLetters: true,
  showReferences: true,
  showBudgets: true,
  showSkillsAssessment: dynamicValues.showSkillsAssessment,
  showCourses: dynamicValues.coursePlanEnabled,
  showUpTheLadder:
    dynamicValues.userProfile?.isRoot ||
    dynamicValues.upTheLadder ||
    dynamicValues.userProfile?.hasUpTheLadderAccess,
  showHistorical: dynamicValues.isSubscriber,
  showFiles: dynamicValues.isSubscriber,
  numToDisplay: 50
}

export const assembleCombinedReport = data => {
  const combinedData = {}

  if (data.ip?.isSummarizable) {
    data.ip.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.ip.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        ip: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  if (data.wip?.isSummarizable) {
    data.wip.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.wip.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        wip: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  if (data.sp?.isSummarizable) {
    data.sp.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.sp.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        sp: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  if (data.skillsAssessment?.isSummarizable) {
    data.skillsAssessment.results.matches.forEach(m => {
      let d = combinedData[m.onetSoc]
      const bonus = m.value >= data.skillsAssessment.results.strongMatch ? 1 : 0.5

      if (!d) {
        d = { numAssessments: 0, combinedScore: 0 }
      }

      combinedData[m.onetSoc] = {
        ...d,
        onetSoc: m.onetSoc,
        skillsAssessment: m.value,
        combinedScore: d.combinedScore + bonus,
        numAssessments: d.numAssessments + 1
      }
    })
  }

  const retVal = Object.values(combinedData)
    .map(m => {
      return {
        ...m,
        combinedScore: m.numAssessments * 0.25 + m.combinedScore
      }
    })
    .sort((a, b) => {
      const initial = b.combinedScore - a.combinedScore

      return initial !== 0 ? initial : a.onetSoc.localeCompare(b.onetSoc)
    })

  return retVal
}

export const setAllOptionsTo = newState => (dispatch, getState) => {
  let newValues = defaultPortfolioSummaryFilters

  if (!newState) {
    newValues = { ...getState().portfolioSummaryReport.filters }

    Object.keys(newValues).forEach(k => {
      console.log(`Found Key: ${k}`)

      if (typeof newValues[k] === 'boolean') {
        console.log(`Found type boolean, setting to ${newState}`)
        newValues[k] = newState
      }
    })
  }

  console.log('Finished, setting to:', newValues)

  return dispatch({ type: TOGGLE_FILTER_TO, newValues })
}

export const save = (user, filters) => dispatch => {
  return dispatch(
    h2Api.post(
      `/user/reports/user/${user ? `${user.id}/` : ''}save`,
      filters
    )({ type: REPORT_DATA_SAVE_PORTFOLIO, user })
  )
    .then(t => {
      console.log('SAVED:', t)
      dispatch({ type: REPORT_DATA_SAVE_PORTFOLIO_COMPLETE })

      return t
    })
    .catch(t => dispatch({ type: REPORT_DATA_SAVE_PORTFOLIO_ERROR }))
}

export const closeConfirm = () => dispatch => {
  dispatch({ type: REPORT_DATA_SAVE_PORTFOLIO_DISMISS })
}

export const print = filters => h2Api.post('/pdfs/portfolio/summaryreport', filters)

export const loadReport = () => {
  return h2Api.get('/api/v2/reports/user')({ type: REPORT_DATA_LOAD })
}

export const loadReportForUser = userId => {
  return h2Api.get(`/api/v2/reports/user/${userId}`)({ type: REPORT_DATA_LOAD })
}

export const toggleFilter = name => dispatch => {
  dispatch({ type: TOGGLE_FILTER, name })
}

export const setNumToDisplay = numToDisplay => dispatch => {
  dispatch({ type: FILTER_NUM_TO_DISPLAY, numToDisplay })
}
